import Image from "next/image"
import { type ComponentProps } from "react"
import { Stack } from "@octopus-energy/coral/atoms"

export function CenteredImage({ src, alt, ...props }: ComponentProps<typeof Image>) {
    return (
        <Stack justifyContent="center">
            <Image
                src={src}
                alt={alt}
                {...props}
            />
        </Stack>
    )
}
